import { Cell, Grid, TextField } from 'bold-ui'

interface EvolucoesPeriodontaisTableHeaderProps {
  onChangeFilter(filter: string): void
}

export const EvolucoesPeriodontaisTableHeader = (props: EvolucoesPeriodontaisTableHeaderProps) => {
  const { onChangeFilter } = props

  return (
    <Grid alignItems='flex-start' gap={1}>
      <Cell md={7} lg={6}>
        <TextField
          placeholder='Pesquise por local, procedimento ou profissional'
          icon='zoomOutline'
          onChange={(e) => onChangeFilter(e.currentTarget.value)}
        />
      </Cell>
    </Grid>
  )
}
